import { useWindowSize } from 'react-use';

const Hero = (props) => {
	const { data } = props;
	const { width } = useWindowSize();

	let picL = '';
	let picM = '';
	let description = '';

	data?.map((crumb) => {
		if (crumb.pic) picL = crumb.pic;
		if (crumb.value01) picM = crumb.value01;
		if (crumb.description) description = crumb.description;
		return crumb;
	});

	return (
		<div className='common-hero'>
			<div className='img' style={{ backgroundImage: `url('${width < 768 && picM ? picM : picL}')` }}></div>
			<div className='heading-wrap'>
				<h1>{description}</h1>
			</div>
		</div>
	);
};

export default Hero;
